import React from 'react';
import PropTypes from 'prop-types';
import ManualPDF from './ManualPDF';
import ManualList from './ManualList';
import ManualTab from './ManualTab';
import Dialog from '../dialogs/Dialog';

/**
 * @typedef {Array} manualList
 * @property {string} manualType - Type of manual
 * @property {string} title - Title of manual
 */

/**
 * @typedef {Object} manualProps
 * @property {bool} hasList - If you need more manuals
 * @property {bool} hasCustom - If you need custom dialog manuals
 * @property {object} listManual - List of manuals from redux
 * @property {object} customManual - List of manuals from redux
 * @property {object} user - User object from redux
 * @property {object} manualBlob - Manual blob from redux
 * @property {string} manualFileName - Name of file
 * @property {string} manualTitle - Title for manual
 * @property {manualList[]} manualList - Manual list
 * @property {array} manualListData - Manual blob from redux
 * @property {object} manualListDataMap - Manual blob from redux
 */

/**
 * ManualWrapper Component
 * @module
 * @param {func} getManual - Function to get manual
 * @param {func} [getListManual] - Function to get manual list
 * @param {func} [getTabListManual] - Function to get tab manual list
 * @param {manualProps} manualProps - Props for manual
 */

const ManualWrapper = (props) => {
  // const [isManualDialogOpen, setIsManualDialogOpen] = useState(false)
  // const [isManualListOpen, setIsManualListOpen] = useState(false)

  const buildManual = () => {
    const { manualProps } = props;
    if (manualProps.hasCustom) {
      return (
        <Dialog
          isOpen={props.isCustomOpen}
          title={'Používateľské príručky'}
          onClose={props.onCustomClose}
          onConfirm={props.onCustomClose}
          hideButtons={true}
        >
          <ManualTab
            manualProps={manualProps}
            getManual={props.getManual}
            getTabListManual={props.getTabListManual}
          />
        </Dialog>
      )
    } else if (manualProps.hasList) {
      return (
        <Dialog
          isOpen={props.isListOpen}
          title={'Používateľské príručky'}
          onClose={props.onListClose}
          onConfirm={props.onListClose}
          hideButtons={true}
        >
          <ManualList
            manualProps={manualProps}
            getManual={props.getManual}
            getListManual={props.getListManual}
          />
        </Dialog>
      )
    } else {
      return (
        <Dialog
          isOpen={props.isManualOpen}
          title={'Používateľská príručka'}
          onClose={props.onManualClose}
          onConfirm={props.onManualClose}
          fullscreen={true}
          className={"fullscreen-report"}
        >
          <ManualPDF
            manualProps={manualProps}
            getManual={props.getManual}
          />
        </Dialog>
      )
    }
  }

  return (
    <>
      {buildManual()}
    </>
  )

}

ManualWrapper.propTypes = {
  getManual: PropTypes.func.isRequired,
  getListManual: PropTypes.func,
  getTabListManual: PropTypes.func,
  manualProps: PropTypes.shape({
    hasList: PropTypes.bool.isRequired,
    hasCustom: PropTypes.bool,
    manualCustom: PropTypes.arrayOf(PropTypes.object),
    listManual: PropTypes.object,
    user: PropTypes.object,
    manualBlob: PropTypes.object,
    manualFileName: PropTypes.string,
    manualTitle: PropTypes.string,
    manualList: PropTypes.arrayOf(PropTypes.object),
    manualListData: PropTypes.array,
    manualListDataMap: PropTypes.object
  }).isRequired
}

export default ManualWrapper;